import { ColorToken } from '@backrs_ui/common-ui/src/designSystem/colors/colors';

import { Box, Theme, SxProps } from '@mui/material';

export type SegmentedBarSegment = Readonly<{
  value: number;
  color: ColorToken;
}>;

export type SegmentedBarChartProps = Readonly<{
  segments: SegmentedBarSegment[];
  maxValue: number;
  height?: number;
}>;

export const SegmentedBarChart = ({ segments, maxValue, height = 24 }: SegmentedBarChartProps) => {
  // Ensure maxValue is not zero
  const safeMaxValue = Math.max(maxValue, 1);

  return (
    <Box sx={{ ...containerSx, height }}>
      {segments.map((segment, index) => {
        const width = Math.max((segment.value / safeMaxValue) * 100, 0.1); // Minimum 0.1% width
        const isFirst = index === 0;
        const isLast = index === segments.length - 1;

        return (
          <Box
            key={index}
            sx={{
              ...segmentSx,
              width: `${width}%`,
              backgroundColor: (theme: Theme) => theme.backrs.colors[segment.color],
              borderTopLeftRadius: (theme: Theme) =>
                isFirst ? theme.backrs.radius['radius-xs'] : 0,
              borderBottomLeftRadius: (theme: Theme) =>
                isFirst ? theme.backrs.radius['radius-xs'] : 0,
              borderTopRightRadius: (theme: Theme) =>
                isLast ? theme.backrs.radius['radius-xs'] : 0,
              borderBottomRightRadius: (theme: Theme) =>
                isLast ? theme.backrs.radius['radius-xs'] : 0,
            }}
          />
        );
      })}
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  overflow: 'hidden',
  display: 'flex',
  width: '200px',
};

const segmentSx: SxProps<Theme> = {
  height: '100%',
  transition: 'width 0.3s ease',
  minWidth: '1px',
};
